// extracted by mini-css-extract-plugin
export default {"clickable":"Icons_clickable__-i0kH"};